<section class="d-flex flex-column justify-content-center gap-4 h-auto">
  <app-panel [item]="item" class="panel" *ngFor="let item of faqs"></app-panel>
</section>
